export const setupPWAInstallPrompt = () => {
  let deferredPrompt;

  const handleBeforeInstallPrompt = (e) => {
    e.preventDefault(); // Prevent the default mini-infobar
    deferredPrompt = e;

    // Show a custom install button (optional)
    const installButton = document.getElementById('install-button');
    if (installButton) {
      installButton.style.display = 'block';

      installButton.addEventListener('click', () => {
        deferredPrompt.prompt(); // Show the install prompt
        deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the PWA installation');
          } else {
            console.log('User dismissed the PWA installation');
          }
          deferredPrompt = null; // Reset the deferred prompt
        });
      });
    }
  };

  window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

  return () => {
    window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  };
};